import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Loader2, Chrome } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { document.title = "Area Riservata — Luca Mannu Giardini"; }, []);

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(apiError(err, "Accesso non riuscito"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-forest px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-sm border border-bone/10 bg-bone p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-2">
          <Leaf className="h-5 w-5 text-terra" strokeWidth={1.5} />
          <span className="font-serif text-2xl tracking-tight text-forest">Luca Mannu <span className="italic">Giardini</span></span>
        </div>
        <p className="mt-2 font-accent text-xs uppercase tracking-[0.25em] text-terra">Area riservata</p>
        <div className="mt-8 flex flex-col gap-5">
          <div>
            <Label htmlFor="admin-email" className="font-accent text-xs uppercase tracking-[0.18em] text-sage">Email</Label>
            <Input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 border-line bg-sand/70 text-forest" data-testid="admin-email-input" />
          </div>
          <div>
            <Label htmlFor="admin-password" className="font-accent text-xs uppercase tracking-[0.18em] text-sage">Password</Label>
            <Input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 border-line bg-sand/70 text-forest" data-testid="admin-password-input" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-forest py-4 font-accent text-sm uppercase tracking-[0.2em] text-bone transition-transform duration-300 hover:scale-[1.02] active:scale-95 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Accedi
          </button>
          <div className="flex items-center gap-4">
            <span className="h-px flex-1 bg-line" />
            <span className="font-accent text-[10px] uppercase tracking-[0.2em] text-sage">oppure</span>
            <span className="h-px flex-1 bg-line" />
          </div>
          <button
            type="button"
            onClick={googleLogin}
            data-testid="admin-google-login"
            className="flex items-center justify-center gap-3 rounded-full border border-forest py-4 font-accent text-sm uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:bg-forest hover:text-bone"
          >
            <Chrome className="h-4 w-4" strokeWidth={1.5} /> Continua con Google
          </button>
        </div>
      </form>
    </main>
  );
}
